import { createStore } from "vuex";
import axios from "axios";
import library from "./library.js";
import events from "./events.js";
import conversations from "./conversations.js";
import contacts from "./contacts.js";

let getDefaultState = () => {
  return {
    user: {
      phoneNumber: "(123) 123-1234",
      tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
      given_name: "Peter",
      createdAt: "2022-03-14T04:53:46.769Z",
      family_name: "Parker",
      email: "hello@simplecityevents.com",
      conversations: [
        {
          id: "1654283067378",
          messages: {
            1654283078127: {
              timeSent: 1654283078127,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              },
              read: false,
              id: 1654283078127,
              reaction: [],
              body: "Hey, Olive!",
            },
            1672298320475: {
              timeSent: 1672298320475,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              },
              read: false,
              id: 1672298320475,
              reaction: [],
              body: "What’s happening?!\n",
            },
            1672298336683: {
              timeSent: 1672298336683,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              },
              read: false,
              id: 1672298336683,
              reaction: [],
              body: "Hhjhh\n",
            },
          },
          participantKeys: [
            {
              phoneNumber: "(636) 212-4414",
              role: "client",
              profilePicture:
                "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1670890084331",
              userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
              given_name: "Cole",
              family_name: "Coleman",
              email: "admin@simplecitysoftware.com",
            },
            {
              phoneNumber: "1234567890",
              role: "client",
              userId: "0f1534da-3974-4be1-a978-88cbb7330537",
              tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
              given_name: "Olive",
              family_name: "Tree",
              username: "testclient@simplecitysoftware.com",
              email: "testclient@simplecitysoftware.co",
            },
          ],
          sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
          contactsRetrieved: true,
        },

        {
          id: "1654283307410",
          messages: {
            1671777489110: {
              timeSent: 1671777489110,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              },
              read: false,
              id: 1671777489110,
              reaction: [],
              body: "Hey, David! Let's start a new chat!\n",
            },
          },
          participantKeys: [
            {
              phoneNumber: "(636) 212-4414",
              role: "client",
              profilePicture:
                "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1670890084331",
              userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
              given_name: "Cole",
              family_name: "Coleman",
              email: "admin@simplecitysoftware.com",
            },
            {
              phoneNumber: "8529637410",
              role: "employee",
              profilePicture:
                "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656116210127",
              userId: "41e7998a-deda-4ec5-8968-09976708aa6a",
              tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
              given_name: "David",
              family_name: "Rose",
              username: "david.rose@simplecitysoftware.com",
              email: "david.rose@simplecitysoftware.com",
            },
          ],
          sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
          contactsRetrieved: true,
        },

        {
          id: "1656116593540",
          messages: {
            1671777637439: {
              timeSent: 1671777637439,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              },
              read: false,
              id: 1671777637439,
              reaction: [],
              body: "What's happenin' Pete!?\n",
            },
          },
          participantKeys: [
            {
              phoneNumber: "(636) 212-4414",
              role: "client",
              profilePicture:
                "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1670890084331",
              userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
              given_name: "Cole",
              family_name: "Coleman",
              email: "admin@simplecitysoftware.com",
            },
            {
              phoneNumber: "1234567894",
              role: "vendor",
              profilePicture:
                "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656116885967",
              userId: "de8abc34-2c29-4aef-ad71-26187c82fe11",
              tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
              given_name: "Peter",
              family_name: "Parker",
              username: "peter.parker@simplecitysoftware.com",
              email: "peter.parker@simplecitysoftware.com",
            },
          ],
          sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
          contactsRetrieved: true,
        },
        {
          id: "1654284404134",
          messages: {
            1654284414855: {
              timeSent: 1654284414855,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
              },
              read: false,
              id: 1654284414855,
              reaction: [],
              body: "Hi, Cole!",
            },
            1654285628370: {
              timeSent: 1654285628370,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              },
              read: false,
              id: 1654285628370,
              reaction: [],
              body: "Hey, Bruce!",
            },
            1657863753599: {
              timeSent: 1657863753599,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              },
              read: false,
              id: 1657863753599,
              reaction: [],
              body: "This is a longer string of text, so it should be two lines long and take up more space",
            },
            1657863779582: {
              timeSent: 1657863779582,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              },
              read: false,
              id: 1657863779582,
              reaction: [],
              body: "k\nk\nk\nk\nk\nk\nk\n",
            },
            1657863813449: {
              timeSent: 1657863813449,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              },
              read: false,
              id: 1657863813449,
              reaction: [],
              body: "this is a longer string of text\n",
            },
            1657863954065: {
              timeSent: 1657863954065,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              },
              read: false,
              id: 1657863954065,
              reaction: [],
              body: "This is a longer string of text, so it should be two lines long and take up more space",
            },
            1657864188663: {
              timeSent: 1657864188663,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              },
              read: false,
              id: 1657864188663,
              reaction: [],
              body: "Hey. Cole!",
            },
            1671772421714: {
              timeSent: 1671772421714,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              },
              read: false,
              id: 1671772421714,
              reaction: [],
              body: "Hey, Bruce! Let's hope this works like it should! What do you say?\n",
            },
            1671809295024: {
              timeSent: 1671809295024,
              senderKey: {
                tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
                userId: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
              },
              read: false,
              id: 1671809295024,
              reaction: [],
              body: "Hey, Cole! Looks like it came through on my end. Do you think it works on your end? Check before yo push this update.\n",
            },
          },
          participantKeys: [
            {
              phoneNumber: "1234567890",
              role: "client",
              userId: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
              tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
              given_name: "Bruce",
              family_name: "Banner",
              username: "bruce.banner@simplecitysoftware.com",
              email: "bruce.banner@simplecitysoftware.com",
            },
            {
              phoneNumber: "(636) 212-4414",
              role: "client",
              profilePicture:
                "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1670890084331",
              userId: "f48f259e-37d9-4003-be97-7181858b98aa",
              tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
              given_name: "Cole",
              family_name: "Coleman",
              email: "admin@simplecitysoftware.com",
            },
          ],
          sortKey: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
          contactsRetrieved: true,
        },
      ],
      role: "client",
      profilePicture:
        "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1670890084331",
      userId: "f48f259e-37d9-4003-be97-7181858b98aa",
    },
    event: undefined,
    contact: undefined,
    eventsRetrieved: false,
    retrievingEvents: false,
    todosRetrieved: false,
    authNeeded: false,
    audioTrack: undefined,
    authenticated: false,
    businessSettings: {
      accent_color: "#705466",
      adjustments: [
        {
          name: "New Adjustment",
          amount: 1,
          id: "adj1660409954996",
          type: "percentage",
          direction: "discount",
        },
        {
          name: "New adjustment",
          amount: 10000,
          type: "dollar",
          direction: "discount",
        },
        {
          name: "New Adjustment",
          amount: 1,
          id: "adj1660410257222",
          type: "percentage",
          direction: "discount",
        },
        {
          name: "New Adjustment",
          amount: -10000,
          type: "dollar",
          direction: "charge",
        },
        {
          name: "New Discount",
          amount: 10000,
          type: "dollar",
          direction: "discount",
        },
        {
          name: "New Adjustment",
          amount: 1,
          id: "adj1660410199967",
          type: "percentage",
          direction: "discount",
        },
        {
          name: "New discount",
          amount: 0.1,
          id: "adj1660415162044",
          type: "percentage",
          direction: "discount",
        },
        {
          name: "New adjustment",
          amount: 0.1,
          type: "percentage",
          direction: "discount",
        },
        {
          name: "New adjustment",
          amount: 0.1,
          id: "adj1660415496554",
          type: "percentage",
          direction: "discount",
        },
        {
          name: "Adjustment",
          amount: 0.05,
          id: "adj1660415529139",
          type: "percentage",
          direction: "discount",
        },
      ],
      automations: [
        {
          action: {
            type: "email",
            toDo: {},
            email: {
              from: "me@simplecityeventcompany.spindj.io",
              subject: "This is a test email!",
              content: "Dur dur, dur dur dur",
            },
          },
          applyToExistingEvents: false,
          contactType: "client",
          approved: false,
          trigger: {
            quantity: "months",
            trigger: "event-date",
            distance: 7,
            immediate: false,
            direction: "before",
          },
          title: "Test Automation (edited)",
        },
        {
          action: {
            type: "email",
            toDo: {},
            email: {
              from: "me@simplecityevents.spindj.io",
              subject: "Hi!",
              content: "This doesn't matter, really",
            },
          },
          applyToExistingEvents: false,
          contactType: "vendor",
          approved: true,
          trigger: {
            quantity: "weeks",
            trigger: "event-date",
            distance: 1,
            immediate: false,
            direction: "before",
          },
          title: "Vendor Check In",
        },
        {
          action: {
            type: "email",
            toDo: {},
            email: {
              from: "hello@simplecityevents.spindj.io",
              subject: "Hi!",
              content: "This doesn't really matter either",
            },
          },
          applyToExistingEvents: false,
          contactType: "client",
          approved: false,
          trigger: {
            quantity: "weeks",
            trigger: "event-date",
            distance: 2,
            immediate: false,
            direction: "after",
          },
          title: "Review Request",
        },
        {
          action: {
            type: "email",
            toDo: {},
            email: {
              from: "hello@simplecityevents.spindj.io",
              subject: "Doesn't Matter",
              content: "This doesn't matter",
            },
          },
          applyToExistingEvents: false,
          contactType: "client",
          approved: true,
          trigger: {
            quantity: "weeks",
            trigger: "event-date",
            distance: 2,
            immediate: false,
            direction: "before",
          },
          title: "2 Week Check In",
        },
        {
          approved: true,
          action: {
            type: "email",
            toDo: {},
            email: {
              from: "me@simplecityevents.spindj.io",
              subject: "asdf",
              content: "asdfasdf",
            },
          },
          contactType: "client",
          applyToExistingEvents: false,
          id: "automation1668824470869",
          trigger: {
            quantity: "weeks",
            trigger: "event-date",
            distance: 3,
            immediate: false,
            direction: "before",
          },
          title: "Automatic Stuff",
        },
        {
          approved: false,
          action: {
            type: "email",
            toDo: {},
            email: {
              from: "hello@simplecityevents.spindj.io",
              subject: "New one",
              content: "<b>Dur Dur</b>",
            },
          },
          contactType: "client",
          applyToExistingEvents: false,
          id: "automation1673633752126",
          trigger: {
            immediate: true,
            trigger: "event-date",
          },
          title: "New automation",
        },
      ],
      businessName: "Simplicity Event Co",
      color_theme: ["#FFFFFF", "#D9D9D9", "#575757"],
      contracts: [
        {
          contractBody:
            "Signer First Name: {given_name}\nSigner Last Name: {family_name}\nEvent Start Time: {event-start-time}\nEvent End Time: {event-end-time}\nEvent Length: {event-length}\nEvent Date: {event-date}\nEvent Title: {event-title}\nInvoice Total: {invoice-total}\nInvoice Subtotal: {invoice-subtotal}\nInvoice Adjustments: {invoice-adjustments}\nInvoice Final Payment Due: {invoice-final-payment-due}\nInvoice Deposit Amount: {invoice-deposit-amount}\nClient List: {client-list}\nLocation List: {location-list}\nBusiness Name: {business-name}",
          contractName: "Merge Tag Contract",
          id: "contract1649954176561",
        },
      ],
      identity: {
        branding: {
          highlightColor: "#52d6fc",
          backgroundColor: "#005392",
          foregroundColor: "#feffff",
          secondaryTextColor: "#424242",
          textColor: "#424242",
          cardOutline: "#a9a9a9",
        },
        businessAddress: {
          cityStateZip: "Anywhere, AZ, 12345",
          streetAddress1: "1234 Street Road",
          streetAddress2: undefined,
        },
        businessLogo:
          "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1669263540401",
        businessName: "Simple City Events",
        businessPhoneNumber: "636-212-4414",
        emailAddresses: [
          "hello@simplecityeventcompany.spindj.io",
          "me@simplecityeventcompany.spindj.io",
          "admin@simplecityeventcompany.spindj.io",
          "system@simplecityevents.spindj.io",
        ],
        phoneNumber: "1231231234",
        subdomain: ["simplecityevents"],
      },
      payments: {
        check: {
          enabled: false,
          instructions:
            "You can write a check and email it to our office at 12345 Anywhere St, Anywhere, NY, 12345.",
        },
        creditCard: {
          QuickBooks: {},
          Square: {},
          Stripe: {},
          enabled: true,
        },
        currencyCode: "USD",
        custom: {
          enabled: true,
          instructions: "Custom payment instructions",
          name: "Custom Payment",
        },
        deposit: {
          amount: "200",
          terminology: "retainer",
          type: "amount",
        },
        depositAmount: 200,
        finalPayment: {
          increment: "2",
          type: "weeks",
        },
        p2p: {
          PayPal: {},
          Venmo: {},
        },
      },
      product: {
        addOns: [
          {
            name: "Uplighting",
            priceOption: "Unit",
            id: "addOn1657129946636",
            pricing: {
              minUnits: 35,
              unitRate: 2000,
            },
          },
          {
            priceOption: "Unit",
            name: "Another One",
            description: "This is another one",
            photo:
              "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1668796693725",
            id: "addOn1668797212000",
            contracts: [],
            pricing: {
              minUnits: 20,
              unitRate: 5000,
            },
            forms: [],
          },
        ],
        discounts: [
          {
            name: "15% Discount",
            amount: 0.15,
            id: "id1657138740405",
            type: "percentage",
            direction: "discount",
          },
          {
            name: "$19 Discount",
            amount: 1900,
            id: "id1657138740405",
            type: "dollar",
            direction: "discount",
          },
        ],
        forms: {
          forms: [
            {
              name: "Music Preference",
              description: "Give me your preferences for music for the day! ",
              id: "form1642369072870",
              fields: [
                {
                  fields: [
                    {
                      options: [],
                      inputTitle: "Favorite Genres",
                      inputType: "text",
                      placeholder: "Rock, Hip-Hop, Raffi",
                    },
                  ],
                  name: "Music Preferences",
                  inputQuantity: "1",
                },
              ],
            },
            {
              name: "Song Request",
              description: "Give me your must plays!",
              id: "form1642378126707",
              fields: [
                {
                  duplicable: true,
                  name: "Song:",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title:",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist:",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes:",
                      inputType: "text",
                      placeholder: "Notes:",
                    },
                  ],
                  libraryEnabled: true,
                },
              ],
              streamingEnabled: true,
            },
            {
              name: "Do Not Play",
              description: "Give me all the songs you HATE!",
              id: "form1642378681111",
              fields: [
                {
                  duplicable: true,
                  name: "Song:",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title:",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist:",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes:",
                      inputType: "text",
                      placeholder: "Notes:",
                    },
                  ],
                  libraryEnabled: true,
                },
              ],
            },
            {
              name: "Ceremony",
              description: "Playlist for wedding ceremony",
              id: "form1642440310328",
              fields: [
                {
                  duplicable: true,
                  name: "Bride Entrance",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes",
                      inputType: "text",
                      placeholder: "Notes",
                    },
                  ],
                  libraryEnabled: true,
                },
                {
                  duplicable: true,
                  name: "Processional",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes",
                      inputType: "text",
                      placeholder: "Notes",
                    },
                  ],
                  libraryEnabled: true,
                },
                {
                  duplicable: false,
                  name: "Interlude",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes",
                      inputType: "text",
                      placeholder: "Notes",
                    },
                  ],
                  libraryEnabled: true,
                },
                {
                  duplicable: false,
                  name: "Recessional",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes",
                      inputType: "text",
                      placeholder: "Notes",
                    },
                  ],
                  libraryEnabled: true,
                },
                {
                  duplicable: true,
                  name: "Custom Song",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes",
                      inputType: "text",
                      placeholder: "Notes",
                    },
                  ],
                  libraryEnabled: true,
                },
                {
                  duplicable: true,
                  name: "Groom Entrance",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title:",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist:",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes:",
                      inputType: "text",
                      placeholder: "Notes:",
                    },
                  ],
                  libraryEnabled: true,
                },
              ],
            },
            {
              name: "Grand Entrance Members",
              description:
                "Enter all of the members of the grand entrance as they'll walk in!",
              id: "form1642440335065",
              fields: [
                {
                  duplicable: true,
                  name: "Person(s):",
                  inputQuantity: "1",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Name(s):",
                      inputType: "text",
                      placeholder: "John Smith and Mary Smith",
                    },
                  ],
                },
              ],
            },
            {
              name: "Wedding Reception",
              description:
                "The big celebration! This is the form for the wedding reception.",
              id: "form1642435090229",
              fields: [
                {
                  duplicable: true,
                  name: "Grand Entrance:",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title:",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist:",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes:",
                      inputType: "text",
                      placeholder: "Notes:",
                    },
                  ],
                  libraryEnabled: true,
                },
                {
                  duplicable: false,
                  name: "First Dance",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title:",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist:",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes:",
                      inputType: "text",
                      placeholder: "Notes:",
                    },
                  ],
                  libraryEnabled: true,
                },
                {
                  duplicable: true,
                  name: "Bride and Parent Dance:",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title:",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist:",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Relation and Name:",
                      inputType: "text",
                      placeholder: "Relation and Name",
                    },
                  ],
                  libraryEnabled: true,
                },
                {
                  duplicable: true,
                  name: "Groom and Parent Dance:",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title:",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist:",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Relation and Name:",
                      inputType: "text",
                      placeholder: "Relation and Name",
                    },
                  ],
                  libraryEnabled: true,
                },
                {
                  duplicable: false,
                  name: "Bouquet Toss:",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title:",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist:",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes:",
                      inputType: "text",
                      placeholder: "Notes:",
                    },
                  ],
                  libraryEnabled: true,
                },
                {
                  duplicable: false,
                  name: "Garter Toss:",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title:",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist:",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes:",
                      inputType: "text",
                      placeholder: "Notes:",
                    },
                  ],
                  libraryEnabled: true,
                },
                {
                  duplicable: false,
                  name: "Cake Cutting:",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title:",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist:",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes:",
                      inputType: "text",
                      placeholder: "Notes:",
                    },
                  ],
                  libraryEnabled: true,
                },
                {
                  duplicable: true,
                  name: "Custom Song:",
                  fields: [
                    {
                      options: [],
                      inputTitle: "Song Title:",
                      inputType: "text",
                      placeholder: "Title",
                    },
                    {
                      options: [],
                      inputTitle: "Song Artist:",
                      inputType: "text",
                      placeholder: "Artist",
                    },
                    {
                      options: [],
                      inputTitle: "Notes:",
                      inputType: "text",
                      placeholder: "Notes:",
                    },
                  ],
                  libraryEnabled: true,
                },
              ],
            },
            {
              name: "New Form",
              description: "new form",
              id: "form1657133469773",
              fields: [
                {
                  name: "new form",
                  duplicable: false,
                  inputQuantity: 1,
                  fields: [
                    {
                      options: [],
                      inputTitle: "new form",
                      inputType: "text",
                      placeholder: "new form",
                    },
                  ],
                  libraryEnabled: false,
                },
                {
                  name: "text",
                  duplicable: false,
                  inputQuantity: 2,
                  fields: [
                    {
                      inputTitle: "lkjl",
                      inputType: "textarea",
                    },
                    {
                      options: ["option one 1", "option 2 two"],
                      inputTitle: "afd",
                      inputType: "select",
                      optionQuantity: 2,
                    },
                  ],
                  libraryEnabled: false,
                },
                {
                  name: "text",
                  duplicable: false,
                  inputQuantity: 2,
                  fields: [
                    {
                      inputTitle: "lkjl",
                      inputType: "textarea",
                    },
                    {
                      options: ["option one 1", "option 2 two"],
                      inputTitle: "afd",
                      inputType: "select",
                      optionQuantity: 2,
                    },
                  ],
                  libraryEnabled: false,
                },
                {
                  name: "text",
                  duplicable: false,
                  inputQuantity: 2,
                  fields: [
                    {
                      inputTitle: "lkjl",
                      inputType: "textarea",
                    },
                    {
                      options: ["option one 1", "option 2 two"],
                      inputTitle: "afd",
                      inputType: "select",
                      optionQuantity: 2,
                    },
                  ],
                  libraryEnabled: false,
                },
              ],
            },
            {
              name: "Test forms",
              description: "this is a description and should look pretty dope",
              id: "form1669179992013",
              fields: [
                {
                  name: "Song Requests",
                  duplicable: true,
                  inputQuantity: 3,
                  fields: [
                    {
                      inputTitle: "Song Artist",
                      inputType: "text",
                    },
                    {
                      inputTitle: "Song Title",
                    },
                    {
                      options: ["Whole Song", "Shortened"],
                      inputTitle: "Duration",
                      inputType: "select",
                      optionsQuantity: 2,
                    },
                  ],
                  libraryEnabled: false,
                },
                {
                  name: "Do Not Play",
                  duplicable: true,
                  fields: [
                    {
                      inputTitle: "Song Name",
                      inputType: "text",
                      placeholder: "Song Name",
                    },
                    {
                      inputTitle: "Song Artist",
                      inputType: "text",
                      placeholder: "Song Artist",
                    },
                    {
                      inputTitle: "Notes",
                      inputType: "text",
                      placeholder: "Notes",
                    },
                  ],
                  libraryEnabled: true,
                },
              ],
            },
            {
              name: "This is a new form",
              description: "Buggy? hopefully not",
              id: "form1673473467250",
              fields: [
                {
                  name: "Field",
                  duplicable: true,
                  fields: [
                    {
                      inputTitle: "Song Name",
                      inputType: "text",
                      placeholder: "Song Name",
                    },
                    {
                      inputTitle: "Song Artist",
                      inputType: "text",
                      placeholder: "Song Artist",
                    },
                    {
                      inputTitle: "Notes",
                      inputType: "text",
                      placeholder: "Notes",
                    },
                  ],
                  libraryEnabled: true,
                },
              ],
              streamingEnabled: true,
            },
          ],
        },
        packages: [
          {
            serviceIds: ["service1656789786931"],
            priceOption: "Hourly",
            name: "Wedding DJ Deluxe",
            description: "This is for weddings!",
            photo:
              "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1668789712976",
            id: "package1668789774188",
            contracts: ["contract1649954176561"],
            pricing: {
              addHourly: 20000,
              baseTime: 4,
              baseRate: 190000,
            },
            forms: [
              "form1642369072870",
              "form1642378126707",
              "form1642378681111",
              "form1642440310328",
              "form1642440335065",
              "form1642435090229",
            ],
          },
          {
            serviceIds: ["service1656789786931", "service1646869172429"],
            priceOption: "Hourly",
            name: "New Package",
            description: "This is a new package description",
            photo:
              "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1668724454404",
            id: "package1668724454403",
            contracts: ["contract1649954176561"],
            pricing: {
              addHourly: null,
              baseTime: 4,
              baseRate: 200000,
            },
            forms: [
              "form1642435090229",
              "form1642440335065",
              "form1642440310328",
              "form1642378681111",
              "form1642378126707",
              "form1642369072870",
            ],
          },
          {
            serviceIds: ["service1656789786931"],
            priceOption: "Hourly",
            name: "Wedding DJ Deluxe",
            description: "This is for weddings!",
            photo:
              "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1668789712976",
            id: "package1668789774188",
            contracts: ["contract1649954176561"],
            pricing: {
              addHourly: 2,
              baseTime: 4,
              baseRate: 19,
            },
            forms: [
              "form1642369072870",
              "form1642378126707",
              "form1642378681111",
              "form1642440310328",
              "form1642440335065",
              "form1642435090229",
              "form1673473467250",
            ],
          },
        ],
        services: [
          {
            employeesRequired: 1,
            priceOption: "Hourly",
            equipmentNeeded: [],
            name: "Weekend Charity DJ",
            id: "service1644173077057",
            contracts: ["contract1642442940375"],
            forms: [
              "form1642369072870",
              "form1642378126707",
              "form1642378681111",
            ],
            pricing: {
              addHourly: 10000,
              baseTime: 4,
              baseRate: 100000,
            },
          },
          {
            employeesRequired: 1,
            priceOption: "Hourly",
            equipmentNeeded: [],
            name: "Weekday Charity DJ",
            id: "service1644173191009",
            contracts: ["contract1642442940375"],
            forms: [
              "form1642369072870",
              "form1642378126707",
              "form1642378681111",
            ],
            pricing: {
              addHourly: 10000,
              baseTime: 4,
              baseRate: 55000,
            },
          },
          {
            employeesRequired: 1,
            priceOption: "Hourly",
            equipmentNeeded: [],
            name: "Weekend Party DJ",
            id: "service1645816493474",
            contracts: ["contract1642442940375"],
            forms: [
              "form1642369072870",
              "form1642378126707",
              "form1642378681111",
            ],
            pricing: {
              addHourly: 10000,
              baseTime: 4,
              baseRate: 140000,
            },
          },
          {
            employeesRequired: 1,
            priceOption: "Flat",
            equipmentNeeded: [],
            name: "Officiant",
            id: "service1646869172429",
            contracts: [],
            pricing: {
              addHourly: 0,
              baseRate: 35000,
            },
            forms: [],
          },
          {
            employeesRequired: 1,
            priceOption: "Hourly",
            equipmentNeeded: [],
            name: "Wedding DJ",
            photo:
              "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656789889789",
            id: "service1656789786931",
            contracts: ["contract1656786709723"],
            pricing: {
              addHourly: 10000,
              baseTime: 4,
              baseRate: 150000,
            },
            forms: [
              "form1642369072870",
              "form1642378126707",
              "form1642378681111",
              "form1642440310328",
              "form1642440335065",
            ],
          },
        ],
      },
      tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
    },
    settingsTenant: undefined,
    tenants: [],
    statuses: [],
    todos: [],
    automations: {},
    contactsRetrieved: false,
    equipment: [],
  };
};
const store = createStore({
  state: getDefaultState(),
  actions: {
    // admin actions
    async searchAWSForLocation(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(`https://api.spindj.io/location/search/aws`, {
            params: {
              search_term: payload,
            },
          })
          .then((res) => {
            resolve(res.data.Results);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    async getAWSLocationDetails(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get("https://api.spindj.io/location/details/aws", {
            params: {
              address: payload,
            },
          })
          .then((res) => {
            resolve(res.data.Place);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    async addEventAutomation(context, payload) {
      context.state.event.automations.push(payload);
    },
    async addLocationToEvent(context, payload) {
      context.commit("addLocationToEvent", payload);
    },
    async removeLocationFromEvent(context, payload) {
      context.commit("removeLocationFromEvent", {
        ...payload,
      });
    },
    async addContactToEvent(context, payload) {
      context.commit("addContactToEvent", payload);
    },
    async removeContactFromEvent(context, payload) {
      context.commit("removeContactFromEvent", payload);
    },
    async addEventToDo(context, payload) {
      context.state.event.toDos.push(payload);
    },

    async completeToDo() {
      setTimeout(() => {}, 300);
    },

    async approveAutomation(context, automation) {
      automation.processing = true;
      setTimeout(() => {
        automation.approved = true;
      }, 400);
    },
    async adminDeleteAutomation(context, payload) {
      let index = context.state.event.automations.findIndex((x) => {
        return x.id == payload.automationId;
      });
      context.state.event.automations.splice(index, 1);
    },

    // contact-based-actions

    async addContact(context, contact) {
      context.commit("addContact", contact);
    },
    async editContact(context, payload) {
      context.commit("editContact", payload);
    },
    async deleteContact(context, payload) {
      context.commit("deleteContact", payload);
    },
    async addLocation(context, location) {
      context.commit("addContact", location);
    },
    // update test
    async sendEmail() {
      return true;
    },
    // messaging actions
    async sendMessage(context, payload) {
      context.commit("sendMessage", payload);
    },
    async createNewConversation(context, payload) {
      context.commit("createNewConversation", payload);
    },
    // event actions
    async addEvent(context, payload) {
      context.commit("addEvent", payload.event);
    },
    async editEvent(context, payload) {
      context.commit("editEvent", payload);
    },

    async deleteEvent() {
      return setTimeout(() => {
        return true;
      }, 300);
    },
    // utlity actions

    async searchTracks(context, payload) {
      return new Promise((resolve) => {
        let tracks = [...context.state.library.tracks];
        let array = [];
        let searchTerm = payload.toLowerCase().replace(/[^a-z0-9]/gi, "");
        if (payload.length > 0) {
          let name;
          let artist;
          array = tracks.filter((x) => {
            if (x["Name"]) {
              name = x["Name"].toLowerCase().replace(/[^a-z0-9]/gi, "");
            }
            if (x["Artist"]) {
              artist = x["Artist"].toLowerCase().replace(/[^a-z0-9]/gi, "");
            }
            if (name.includes(searchTerm) || artist.includes(searchTerm)) {
              return true;
            } else if (
              searchTerm.includes(name) ||
              searchTerm.includes(artist)
            ) {
              return true;
            }
          });
        }
        let exactMatch = array.find((x) => {
          let name;
          let artist;
          if (x["Name"]) {
            name = x["Name"].toLowerCase().replace(/[^a-z0-9]/gi, "");
          }
          if (x["Artist"]) {
            artist = x["Artist"].toLowerCase().replace(/[^a-z0-9]/gi, "");
          }
          if (searchTerm.includes(name) && searchTerm.includes(artist)) {
            return true;
          } else {
            return false;
          }
        });

        if (exactMatch) {
          resolve([exactMatch]);
        } else {
          resolve(array);
        }
      });
    },
    findStreamingMatch(context, payload) {
      let tracks = [...context.state.library.tracks];
      return tracks.filter((x) => {
        return (
          x["Name"] == payload.name &&
          payload.artists.find((artist) => {
            return artist.name === x["Artist"];
          })
        );
      });
    },
    // Spotify
    async getSpotifyPlaylist(context, playlistURL) {
      return new Promise((resolve, reject) => {
        let playlistId = () => {
          let array = playlistURL.split("/");
          return array[array.length - 1];
        };
        axios
          .get(`https://api.spindj.io/spotify/playlist/${playlistId()}`)
          .then((res) => {
            console.log(res);
            resolve(res.data);
          })
          .catch((e) => {
            console.log(e);
            reject(e);
          });
      });
    },
  },
  mutations: {
    // public mutations ///////////////////////////////
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setUser(state, user) {
      state.user = user;
    },
    searchForUser(state, user) {
      return contacts.find((x) => {
        let id = user.key ? user.key.userId : user.userId ? user.userId : user;
        return x.userId == id;
      });
    },
    updateConfig(state, payload) {
      switch (payload.category) {
        case "addOns":
          switch (payload.operation) {
            case "add":
              state.businessSettings.product.addOns.push(payload.subject);
              break;
            case "delete":
              state.businessSettings.product.addOns.splice(payload.index, 1);
              break;
            case "edit":
              state.businessSettings.product.addOns[payload.index] =
                payload.subject;
              break;
          }
          break;
        case "packages":
          switch (payload.operation) {
            case "add":
              state.businessSettings.product.packages.push(payload.subject);
              break;
            case "delete":
              state.businessSettings.product.packages.splice(payload.index, 1);
              break;
            case "edit":
              state.businessSettings.product.packages[payload.index] =
                payload.subject;
              break;
          }
          break;
        case "services":
          switch (payload.operation) {
            case "add":
              state.businessSettings.product.services.push(payload.subject);
              break;
            case "delete":
              state.businessSettings.product.services.splice(payload.index, 1);
              break;
            case "edit":
              state.businessSettings.product.services[payload.index] =
                payload.subject;
              break;
          }
          break;
        case "adjustments":
          switch (payload.operation) {
            case "add":
              state.businessSettings.product.adjustments.push(payload.subject);
              break;
            case "delete":
              state.businessSettings.product.adjustments.splice(
                payload.index,
                1
              );
              break;
            case "edit":
              state.businessSettings.product.adjustments[payload.index] =
                payload.subject;
              break;
          }
          break;
        case "automations":
          switch (payload.operation) {
            case "add":
              state.businessSettings.automations.push(payload.subject);
              break;
            case "delete":
              state.businessSettings.automations.splice(payload.index, 1);
              break;
            case "edit":
              state.businessSettings.automations[payload.index] =
                payload.subject;
              break;
          }
          break;
        case "forms":
          switch (payload.operation) {
            case "add":
              state.businessSettings.product.forms.push(payload.subject);
              break;
            case "delete":
              state.businessSettings.product.forms.splice(payload.index, 1);
              break;
            case "edit":
              state.businessSettings.product.forms[payload.index] =
                payload.subject;
              break;
          }
          break;
        case "contracts":
          switch (payload.operation) {
            case "add":
              state.businessSettings.contracts.push(payload.subject);
              break;
            case "delete":
              state.businessSettings.contracts.splice(payload.index, 1);
              break;
            case "edit":
              state.businessSettings.contracts[payload.index] = payload.subject;
              break;
          }
          break;
        case "payments":
          switch (payload.variable) {
            case "deposit_amount":
              state.businessSettings.payments.deposit.amount = payload.subject;
              break;
            case "deposit_type":
              state.businessSettings.payments.deposit.type = payload.subject;
              break;
            case "deposit_terminology":
              state.businessSettings.payments.deposit.terminology =
                payload.subject;
              break;
            case "final_payment_type":
              state.businessSettings.payments.finalPayment.type =
                payload.subject;
              break;
            case "final_payment_increment":
              state.businessSettings.payments.finalPayment.type =
                payload.subject;
              break;
            case "custom_enabled":
              state.businessSettings.payments.custom.enabled = payload.subject;
              break;
            case "custom_instructions":
              state.businessSettings.payments.custom.instructions =
                payload.subject;
              break;
            case "check_enabled":
              state.businessSettings.payments.check.enabled = payload.subject;
              break;
            case "check_instructions":
              state.businessSettings.payments.check.instructions =
                payload.subject;
              break;
            case "credit_card_enabled":
              state.businessSettings.payments.creditCard.enabled =
                payload.subject;
              break;
            case "currency_code":
              state.businessSettings.payments.currencyCode = payload.subject;
              break;
          }
          break;
        case "identity":
          switch (payload.variable) {
            case "business_name":
              state.businessSettings.identity.businessName = payload.subject;
              break;
            case "phone_number":
              state.businessSettings.identity.phoneNumber = payload.subject;
              break;
            case "street_address_1":
              state.businessSettings.identity.businessAddress.streetAddress1 =
                payload.subject;
              break;
            case "street_address_2":
              state.businessSettings.identity.businessAddress.streetAddress2 =
                payload.subject;
              break;
            case "cityStateZip":
              state.businessSettings.identity.businessAddress.cityStateZip =
                payload.subject;
              break;
            case "business_logo":
              state.businessSettings.identity.businessLogo = payload.subject;
              break;
            case "color_theme":
              console.log("sup, dawg");
              console.log(payload.subject);
              state.businessSettings.color_theme = payload.subject;
              break;
            case "accent_color":
              state.businessSettings.accent_color = payload.subject;
              break;
            case "emailAddresses":
              switch (payload.operation) {
                case "add":
                  state.businessSettings.identity.emailAddresses.push(
                    payload.subject
                  );
                  break;
                case "delete":
                  state.businessSettings.identity.emailAddresses.splice(
                    payload.index,
                    1
                  );

                  break;

                default:
                  break;
              }
              break;
          }
          break;
        default:
          break;
      }
    },
    setBusinessSettings(state, payload) {
      state.businessSettings = payload.settings;
      state.settingsTenant = payload.tenant;
    },
    setTodos(state, todos) {
      state.todos = todos;
    },
    setPublicSettings(state, settings) {
      state.businessSettings = settings;
    },

    // contact mutations /////////////////////////////
    setContacts(state, payload) {
      contacts.push(...payload);
    },
    addContact(state, payload) {
      contacts.push(payload);
    },
    editContact(state, payload) {
      let subject = payload.contact
        ? payload.contact
        : contacts.find((x) => {
            return x.userId == payload.key.userId;
          });
      if (subject) {
        subject[payload.variable] = payload.value;
      }
      if (state.contact) {
        if (state.contact.userId === payload.key.userId) {
          state.contact[payload.variable] = payload.value;
        }
      }
    },
    deleteContact(state, payload) {
      let index = contacts.findIndex(
        (e) => e.userId === payload.userKey.userId
      );
      if (index > -1) {
        contacts.splice(index, 1);
      }
    },

    // event mutations ////////////////////////////

    addEvent(state, payload) {
      events.push({ ...payload, userId: "event" + Date.now() });
    },
    editEvent(state, payload) {
      let { api_version, variable, value, operation, index } = payload;
      let subject = state.event;
      switch (api_version) {
        case "9-28-2022":
          switch (variable) {
            case "contacts":
            case "locations":
            case "forms":
            case "invoice_adjustments":
            case "notes":
            case "invoice_payments":
            case "invoice_products":
              if (operation === "add") {
                subject[variable].push(value);
              }
              if (operation === "remove") {
                if (!index === undefined) {
                  index = subject[variable].findIndex((x) => {
                    return x.id ? x.id === value.id : x.name === value.name;
                  });
                }
                subject[variable].splice(index, 1);
              }
              break;
            default:
              subject[variable] = value;
              break;
          }
          break;
        default:
          switch (variable) {
            case "contacts":
            case "contracts":
            case "locations":
            case "notes":
            case "forms":
              if (operation === "add") {
                subject[variable].push(value);
              }
              if (operation === "remove") {
                if (index === undefined) {
                  index = subject[variable].findIndex((x) => {
                    return x.id ? x.id === value.id : x.name === value.name;
                  });
                }
                subject[variable].splice(index, 1);
              }
              break;
            case "invoice_adjustments":
              if (operation === "add") {
                subject.invoice.adjustments.push(value);
              }
              if (operation === "remove") {
                let index = subject.invoice.adjustments.findIndex((x) => {
                  return x.id ? x.id === value.id : x.name === value.name;
                });
                subject.invoice.adjustments.splice(index);
              }
              break;
            case "invoice_payments":
              if (operation === "add") {
                subject.invoice.payments.push(value);
              }
              if (operation === "remove") {
                let index = subject.invoice.payments.findIndex((x) => {
                  return x.id ? x.id === value.id : x.name === value.name;
                });
                subject.invoice.payments.splice(index);
              }
              break;
            case "invoice_products":
              if (operation === "add") {
                subject.invoice.products.push(value);
              }
              if (operation === "remove") {
                let index = subject.invoice.products.findIndex((x) => {
                  return x.id ? x.id == value.id : x.name == value.name;
                });
                subject.invoice.products.splice(index);
              }
              break;
            case "start_time":
              subject.data.startTime = value;
              break;
            case "end_time":
              subject.data.endTime = value;
              break;
            case "date":
              subject.data.date = value;
              break;
            default:
              subject[variable] = value;
              break;
          }

          break;
      }
    },
    addLocationToEvent(state, location) {
      state.event.locations.push(location);
    },
    removeLocationFromEvent(state, payload) {
      let { location } = payload;
      let index = state.event.locations.indexOf(location);
      state.event.locations.splice(index, 1);
    },
    addContactToEvent(state, payload) {
      if (payload.contact) {
        state.event.contacts.push(payload.contact);
      }
    },

    removeContactFromEvent(state, payload) {
      let index = state.event.contacts.indexOf(payload);
      state.event.contacts.splice(index, 1);
    },
    addPaymentToEvent(state, payload) {
      state.event.invoice.payments.push(payload);
    },
    setEvent(state, payload) {
      state.event = payload;
    },
    clearEvent(state) {
      state.event = undefined;
    },
    setContact(state, payload) {
      state.contact = payload;
    },
    setEvents(state, payload) {
      events.push(...payload);
    },

    // message specific mutations

    sendMessage(state, payload) {
      let { body, conversationKey } = payload;
      let { id } = conversationKey;
      let activeConversation = conversations.find((x) => {
        return x.id === id;
      });
      activeConversation.messages[body.id] = body;
    },
    createNewConversation(state, payload) {
      conversations.push(payload);
    },

    // media player actions
    playAudio(state, track) {
      state.audioTrack = track;
    },
    unloadTrack(state) {
      state.audioTrack = undefined;
    },
  },
  getters: {
    events: () => (period, sort) => {
      let eventsArr = [
        ...events.filter((x) => {
          return x;
        }),
      ];
      if (period === "past") {
        eventsArr = events.filter((x) => {
          switch (x.api_version) {
            case "9-28-2022":
              return new Date(x.start_time) < new Date();
            default:
              return new Date(x.data.startTime) < new Date();
          }
        });
      } else if (period === "future") {
        eventsArr = events.filter((x) => {
          switch (x.api_version) {
            case "9-28-2022":
              return new Date(x.end_time) > new Date();
            default:
              return new Date(x.data.endTime) > new Date();
          }
        });
      }
      if (sort) {
        return eventsArr.sort(sort);
      } else {
        return eventsArr;
      }
    },
    event(state) {
      return state.event;
    },
    user(state) {
      return state.user;
    },
    userRole(state) {
      if (state.user.tenantId === state.user.userId) {
        return "admin";
      } else {
        return state.user.role;
      }
    },
    todos(state) {
      return state.todos;
    },
    // business settings getters
    // // business settings identity getters
    businessLogo(state) {
      let defaultLogo = "../assets/spin-logo-with-text.svg";
      if (state.businessSettings) {
        if (state.businessSettings.identity) {
          return state.businessSettings.identity.businessLogo;
        } else {
          return defaultLogo;
        }
      } else {
        return defaultLogo;
      }
    },
    businessEmailAddresses(state) {
      if (state.businessSettings) {
        if (state.businessSettings.identity) {
          return state.businessSettings.identity.emailAddresses;
        }
      }
      return [];
    },
    businessEmailAddress(state) {
      return state.businessSettings.identity.businessEmailAddress;
    },
    colorTheme(state) {
      if (state.user) {
        if (state.businessSettings.color_theme) {
          return state.businessSettings.color_theme;
        } else {
          return ["#FFFFFF", "#D9D9D9", "#575757"];
        }
      } else {
        return ["#FFFFFF", "#D9D9D9", "#575757"];
      }
    },
    highlightColor(state) {
      if (state.user) {
        if (state.businessSettings) {
          if (state.businessSettings.accent_color) {
            return state.businessSettings.accent_color;
          }
          if (state.businessSettings.identity) {
            if (state.businessSettings.identity.branding) {
              return state.businessSettings.identity.branding.highlightColor;
            }
          }
        }
      }
      return "#FFD1D1";
    },
    businessAddress(state) {
      if (state.businessSettings) {
        if (state.businessSettings.identity) {
          return state.businessSettings.identity.businessAddress;
        }
      }
      return {};
    },
    businessName(state) {
      if (state.businessSettings) {
        if (state.businessSettings.identity) {
          return state.businessSettings.identity.businessName;
        }
      }
      return "";
    },
    businessPhoneNumber(state) {
      if (state.businessSettings) {
        if (state.businessSettings.identity) {
          return state.businessSettings.identity.phoneNumber;
        }
      }
    },
    automations(state) {
      if (state.businessSettings) {
        if (state.businessSettings.automations) {
          return state.businessSettings.automations;
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    // // business settings product getters
    addOns(state) {
      if (state.businessSettings) {
        if (state.businessSettings.product) {
          if (state.businessSettings.product.addOns) {
            return state.businessSettings.product.addOns;
          } else {
            return [];
          }
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    contracts(state) {
      if (state.businessSettings) {
        return state.businessSettings.contracts;
      } else {
        return [];
      }
    },
    adjustments(state) {
      if (state.businessSettings) {
        if (state.businessSettings.product) {
          if (state.businessSettings.product.discounts) {
            return state.businessSettings.product.discounts;
          } else {
            return [];
          }
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    forms(state) {
      if (state.businessSettings) {
        if (state.businessSettings.product) {
          if (state.businessSettings.product.forms) {
            if (state.businessSettings.product.forms.forms) {
              return state.businessSettings.product.forms.forms;
            } else {
              return [];
            }
          } else {
            return [];
          }
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    formTemplates(state) {
      if (state.businessSettings.product.forms.fieldTemplates) {
        return state.businessSettings.product.forms.fieldTemplates;
      } else {
        return [];
      }
    },
    packages(state) {
      if (state.businessSettings) {
        if (state.businessSettings.product) {
          if (state.businessSettings.product.packages) {
            return state.businessSettings.product.packages;
          } else {
            return [];
          }
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    services(state) {
      if (state.businessSettings) {
        if (state.businessSettings.product) {
          if (state.businessSettings.product.services) {
            return state.businessSettings.product.services;
          } else {
            return [];
          }
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    // // business settings payments getters
    paymentSettings(state) {
      if (state.businessSettings) {
        return state.businessSettings.payments;
      } else {
        return {};
      }
    },
    currencyCode(state) {
      if (state.businessSettings) {
        if (state.businessSettings.payments) {
          if (state.businessSettings.payments.currencyCode) {
            return state.businessSettings.payments.currencyCode;
          } else {
            return "USD";
          }
        } else {
          return "USD";
        }
      } else {
        return "USD";
      }
    },
    depositType(state) {
      if (state.businessSettings) {
        if (state.businessSettings.payments) {
          if (state.businessSettings.payments.deposit) {
            if (state.businessSettings.payments.deposit.type) {
              return state.businessSettings.payments.deposit.type;
            } else {
              return "dollar";
            }
          } else {
            return "dollar";
          }
        } else {
          return "dollar";
        }
      } else {
        return "dollar";
      }
    },
    depositAmount(state) {
      if (state.businessSettings) {
        if (state.businessSettings.payments) {
          if (state.businessSettings.payments.deposit) {
            return state.businessSettings.payments.deposit.amount;
          } else if (state.businessSettings.payments.depositAmount) {
            return state.businessSettings.payments.depositAmount;
          } else {
            return "100";
          }
        } else {
          return "100";
        }
      } else {
        return "100";
      }
    },
    depositTerminology(state) {
      if (state.businessSettings) {
        if (state.businessSettings.payments) {
          if (state.businessSettings.payments.deposit) {
            if (state.businessSettings.payments.deposit.terminology) {
              return state.businessSettings.payments.deposit.terminology;
            } else {
              return "deposit";
            }
          } else {
            return "deposit";
          }
        } else {
          return "deposit";
        }
      } else {
        return "deposit";
      }
    },
    finalPaymentSettings(state) {
      if (state.businessSettings) {
        if (state.businessSettings.payments) {
          if (state.businessSettings.payments.finalPayment) {
            return state.businessSettings.payments.finalPayment;
          } else {
            return {
              increment: 2,
              type: "weeks",
            };
          }
        } else {
          return {
            increment: 2,
            type: "weeks",
          };
        }
      } else {
        return {
          increment: 2,
          type: "weeks",
        };
      }
    },
    finalPaymentIncrement(state) {
      if (state.businessSettings) {
        if (state.businessSettings.payments) {
          if (state.businessSettings.payments.finalPayment) {
            return state.businessSettings.payments.finalPayment.increment;
          } else {
            return 2;
          }
        } else {
          return 2;
        }
      } else {
        return 2;
      }
    },
    finalPaymentType(state) {
      if (state.businessSettings) {
        if (state.businessSettings.payments) {
          if (state.businessSettings.payments.finalPayment) {
            return state.businessSettings.payments.finalPayment.type;
          } else {
            return "weeks";
          }
        } else {
          return "weeks";
        }
      } else {
        return "weeks";
      }
    },
    creditCardEnabled(state) {
      if (state.businessSettings) {
        if (state.businessSettings.payments) {
          if (state.businessSettings.payments.creditCard.enabled) {
            return state.businessSettings.payments.creditCard.enabled;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    checkEnabled(state) {
      if (state.businessSettings) {
        if (state.businessSettings.payments) {
          if (state.businessSettings.payments.check.enabled) {
            return state.businessSettings.payments.check.enabled;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    checkInstructions(state) {
      if (state.businessSettings) {
        if (state.businessSettings.payments) {
          if (state.businessSettings.payments.check.instructions) {
            return state.businessSettings.payments.check.instructions;
          } else {
            return "";
          }
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    customPaymentName(state) {
      if (state.businessSettings) {
        if (state.businessSettings.payments) {
          if (state.businessSettings.payments.custom.name) {
            return state.businessSettings.payments.custom.name;
          } else {
            return "";
          }
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    customPaymentInstructions(state) {
      if (state.businessSettings) {
        if (state.businessSettings.payments) {
          if (state.businessSettings.payments.custom.instructions) {
            return state.businessSettings.payments.custom.instructions;
          } else {
            return "";
          }
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    customPaymentEnabled(state) {
      if (state.businessSettings) {
        if (state.businessSettings.payments) {
          if (state.businessSettings.payments.custom.enabled) {
            return state.businessSettings.payments.custom.enabled;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    // contact getters
    contacts() {
      return contacts;
    },
    clients: () => (sortFunction) => {
      let clients = contacts.filter((x) =>
        x.role ? x.role === "client" : false
      );
      if (sortFunction) {
        clients = clients.sort(sortFunction);
      }
      return clients;
    },
    employees: () => (sortFunction) => {
      let employees = contacts.filter((x) =>
        x.role ? x.role === "employee" : false
      );
      if (sortFunction) {
        employees = employees.sort(sortFunction);
      }
      return employees;
    },
    organizers: () => (sortFunction) => {
      let organizers = contacts.filter((x) =>
        x.role ? x.role === "organizer" : false
      );
      if (sortFunction) {
        organizers = organizers.sort(sortFunction);
      }
      return organizers;
    },
    vendors: () => (sortFunction) => {
      let vendors = contacts.filter((x) =>
        x.role ? x.role === "vendor" : false
      );
      if (sortFunction) {
        vendors = vendors.sort(sortFunction);
      }
      return vendors;
    },
    locations: () => (sortFunction) => {
      let locations = contacts.filter((x) =>
        x.role ? x.role === "location" : false
      );
      if (sortFunction) {
        locations = locations.sort(sortFunction);
      }
      return locations;
    },
    libraryTracks: () => (page) => {
      if (page !== undefined) {
        let start = page * 100;
        let end = (page + 1) * 100;
        return library.tracks.slice(start, end);
      } else {
        return library.tracks;
      }
    },
    libraryMeta() {
      return library.meta;
    },

    // messaging getters
    conversations() {
      return conversations;
    },
    getConversation: () => (id) => {
      return conversations.find((x) => {
        return x.id === id;
      });
    },
  },
});

export default store;
